import { QueryClient } from '@tanstack/react-query'

// 5 minutes is reasonable for static/admin reads (users, roles, tournament
// configs) but catastrophic for live data — a viewer on a live match would
// see a 5-minute-old score between SSE pushes. The default below stays at
// 5 minutes for the bulk of the app; live queries opt in to `LIVE_STALE_TIME`
// via the per-query `staleTime` option.
const DEFAULT_STALE_TIME = 5 * 60 * 1000 // 5 minutes
const DEFAULT_GC_TIME = 10 * 60 * 1000    // 10 minutes

/**
 * Use this `staleTime` for any query backing a live match / live scoring
 * UI. Tells React Query the cached value is immediately stale, so a
 * re-render after an SSE push always re-fetches if the user navigates
 * back to the page. The push channel still does the heavy lifting — this
 * just makes sure cache doesn't fight the live channel.
 */
export const LIVE_STALE_TIME = 0
export const LIVE_GC_TIME = 60_000 // 1 min — drop cache shortly after unmount

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      gcTime: DEFAULT_GC_TIME,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
